import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(0,98,105)',
      dark: 'rgb(0,85,91)',
      light: 'rgb(0,120,128)',
      contrastText: '#fff',
    },
    secondary: {
      main: 'rgb(0,120,128)',
      dark: 'rgb(0,98,105)',
      light: 'rgb(38,166,154)',
      contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;
